import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { ConsItems } from './ConsItems';
import { ProsItems } from './ProsItems';

export const ProsAndConsSection = ({
  pros,
  cons,
}: {
  pros?: StructuredContentDocument[] | string[];
  cons?: StructuredContentDocument[] | string[];
}) => {
  return (
    <Grid container spacing="1.5rem" sx={{ alignItems: 'stretch' }}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'neutral.lighter',
            borderRadius: '0.5rem',
            padding: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography sx={{ fontWeight: 'bold', pb: 2 }}>Pros</Typography>
          {pros?.map((pro, index) => (
            <ProsItems key={`pros-${index}`} pro={pro} />
          ))}
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'neutral.lighter',
            borderRadius: '0.5rem',
            padding: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography sx={{ fontWeight: 'bold', pb: 2 }}>Cons</Typography>
          {cons?.map((con, index) => (
            <ConsItems key={`cons-${index}`} con={con} />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};
